<div class="row" *ngIf="metadata && metadata.length > 0">
  <div class="col-12">
    <table class="table">
      <caption class="sr-only">Tabella metadati</caption>
      <thead>
        <tr>
          <th class="col-xs-3">Identificativo</th>
          <th class="col-xs-3">Nome campo personalizzato</th>
          <th class="col-xs-2">Tipo</th>
          <th class="col-xs-2">Valore</th>
          <th class="col-xs-2"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let meta of metadata">
          <td class="col-xs-3 cell">{{meta.identifier}}</td>
          <td class="col-xs-3 cell">{{meta.name}}</td>
          <td class="col-xs-2 cell">{{meta.type.name}}</td>
          <td class="col-xs-2 cell">{{meta.value}}</td>
          <td class="rightaligned">
            <div class="data_opzioni classificazione">
              <ul>
                <li class="opzioni" appDropdownFocus>
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                    aria-expanded="false">Opzioni<span class="glyphicon glyphicon-option-vertical"></span></a>
                  <div class="dropdown-menu dropdown-table">
                    <ul>
                      <li><span class="glyphicon glyphicon-trash"></span> <a href="javascript:void(0)"
                        (click)="removeAssociation(meta.joinId)">Elimina</a>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

